import { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useProductsAnalytics } from '@client/analytics/context/products/ProductsAnalyticsContext';
import { useRemoteRecordsAnalytics } from '@client/analytics/hooks';
import { analyzeProductDetailsPageView } from '@client/analytics/redux/products/actions';
import { Page } from '@client/app/components/App/Page';
import { isEmpty } from '@client/common/utils/empty/empty';
import { Content } from '@client/product/components/ProductPage/Content';
import { Props } from './ProductPage.types';

export const ProductPage = ({ metaTags, product: productRecord }: Props): ReactElement | null => {
  const { data: product, isLoaded } = productRecord;
  const params = useParams<{ sku: string }>();
  const sku = params.sku || '';
  const { analyzeProductAddToCart } = useProductsAnalytics();

  const enableAnalytics = useRemoteRecordsAnalytics(
    [productRecord],
    () => analyzeProductDetailsPageView(sku),
  );

  useEffect(() => {
    enableAnalytics();
  }, [sku]);

  if (!isLoaded || isEmpty(product) || !product) {
    return null;
  }

  const handleAddToCart = (sku: string) => {
    analyzeProductAddToCart({ sku });
  };

  return (
    <Page
      className='Product'
      title={product.description.title}
      metaTags={metaTags}
    >
      <Content
        product={product}
        onAddToCart={handleAddToCart}
      />
    </Page>
  );
};
